export default __webpack_public_path__ + "static/media/mailIcon.4eadb46b.svg";